import { useState } from "react";

import BillsUsagePage from "./BillsUsagePage";
import BillsUsageDownload from "./BillsUsageDownload";
import Button from "../Input/Button";
import * as Icon from "react-bootstrap-icons";

export default function BillsUsage() {
  const [subPage, setSubPage] = useState("default");
  return (
    <>
      <div className="individual-wrapper">
        {subPage === "default" && (
          <div className="individual-header">
            <h1>Bills &amp; Usage</h1>
            <Button
              className="btn btn--green btn--bordered"
              text="Download Data"
              onClick={() => {
                setSubPage("download");
              }}
              icon={<Icon.Download className="header-btn-icon mr-2 " />}
            />
          </div>
        )}
        {subPage === "download" && (
          <span
            className="page-back-link"
            onClick={() => {
              setSubPage("default");
            }}>
            <Icon.ChevronLeft className="page-back-link-icon" />{" "}
            <p className="page-back-link-text">Back</p>
          </span>
        )}
        {subPage === "default" && <BillsUsagePage />}
        {subPage === "download" && <BillsUsageDownload />}
      </div>
    </>
  );
}
